export default __webpack_public_path__ + "static/media/Brooster-Rooster-about.aa9da36d.png";